import React from 'react'
import {MapFeaturesContext} from "../MapFeaturesContextProvider";

export const useMapFeaturesContext = () => React.useContext(MapFeaturesContext)